import styled from 'styled-components';

export const Wrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    text-align: center;
    justify-content: center;
    align-items: center;
`;
export default Wrapper;
